<template>
  <div class="page">
    <div class="layout">
      <el-row type="flex" align="middle" justify="space-between">
        <el-col :span="8">
          <div class="page-title">題目列表</div>
        </el-col>
        <el-col :span="16" style="text-align: right;">
          <el-button size="mini" v-if="userInfoRoleRoleId !== teacherRoleId" type="info" @click.native="onAdd">新增題目</el-button>
          <el-button size="mini" type="info" @click="batchCopy">批量複製</el-button>
        </el-col>
      </el-row>

      <div class="page-box">
        <div class="page-box-content">
          <div class="page-content-row">
            <div>
              <div class="search-text">題目編號</div>
              <el-input v-model="listQuery.questionNoLike" placeholder="請輸入題目編號"></el-input>
            </div>
            <div>
              <div class="search-text">題目類型</div>
              <el-select v-model="listQuery.type" placeholder="請選擇題目類型">
                <el-option
                  v-for="item in questionTypes" :key="item.value"
                  :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </div>
            <div>
              <div class="search-text">最後更新帳號</div>
              <el-input v-model="listQuery.editorLike" placeholder="請輸入最後更新帳號"></el-input>
            </div>
            <div>
              <div class="search-text">課程版本</div>
              <el-select v-model="listQuery.lang" placeholder="請選擇課程版本">
                <el-option
                  v-for="item in language" :key="item.value"
                  :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </div>
            <div>
              <div class="search-text">最低總答次</div>
              <el-input v-model="listQuery.answerTotalCount" placeholder="請輸入最低總答次"></el-input>
            </div>
            <div>
              <el-button size="mini" type="info" class="button-el-el" @click="onSearch">搜尋</el-button>
            </div>
          </div>
        </div>
        <el-table @sort-change="handleSortChange" :data="tableData" style="width: 100%" @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="55" align="center"></el-table-column> <!-- 添加复选框列 -->
          <el-table-column
              prop="questionNo"
              label="題目編號"
              align="center"
              sortable="custom"
          >
          </el-table-column>
          <el-table-column
              prop="typeConvert"
              label="題目類型"
              align="center">
          </el-table-column>
          <el-table-column
              prop="langConvert"
              label="課程版本"
              align="center">
          </el-table-column>
           <el-table-column
             prop="updatedAt"
            label="最後更新時間"
            align="center"
             sortable="custom"
          >
           <template slot-scope="{row}">
               <span>{{row.updatedAt | formatDateTime}}</span>
           </template>
          </el-table-column>
          <el-table-column
            prop="editor"
            label="最後更新帳號"
            align="center"
          >
           <template slot-scope="{row}">
               <span>{{row.editor}}</span>
           </template>
          </el-table-column>
          <el-table-column
              prop="answer_total_count"
              label="總答次"
              align="center"
              sortable="custom"
          >
            <template slot-scope="{row}">
              <span>{{row.answerTotalCount}}</span>
            </template>
          </el-table-column>
          <el-table-column
              prop="average_score_percent"
              label="答對率"
              align="center"
              sortable="custom"
          >
            <template slot-scope="{row}">
              <span>{{row.averageScorePercent}}%</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="100">
            <template slot-scope="{ row }">
              <!-- 下拉按钮，完全使用你原来的点击方法 -->
              <el-dropdown size="mini">
                <el-button type="text" icon="el-icon-more" size="medium">
                  操作
                </el-button>
                <el-dropdown-menu slot="dropdown">

                  <!-- 複製 -->
                  <el-dropdown-item
                      v-if="userInfoRoleRoleId !== teacherRoleId"
                      @click.native="onCopyButton(row.id)"
                  >
                    複製
                  </el-dropdown-item>

                  <!-- 編輯 -->
                  <el-dropdown-item
                      v-if="userInfoRoleRoleId !== teacherRoleId"
                      @click.native="onEditButton(row.id)"
                  >
                    編輯
                  </el-dropdown-item>

                  <!-- 編輯II -->
                  <el-dropdown-item
                      v-if="userInfoRoleRoleId !== teacherRoleId"
                      @click.native="onEditButton2(row.id)"
                  >
                    編輯II
                  </el-dropdown-item>

                  <!-- 刪除 -->
                  <el-dropdown-item
                      v-if="userInfoRoleRoleId !=teacherRoleId && userInfoRoleRoleId !=editorRoleId"
                      @click.native="onDeleteButton(row)"
                      divided
                  >
                    刪除
                  </el-dropdown-item>

                  <!-- 詳情 -->
                  <el-dropdown-item @click.native="onDetailButton(row.id)">
                    詳情
                  </el-dropdown-item>

                  <!-- 預覽 -->
                  <el-dropdown-item @click.native="openDialogPreview(row)">
                    預覽
                  </el-dropdown-item>

                  <!-- 預覽(新頁面) -->
                  <el-dropdown-item @click.native="openPreviewInNewTab(row)">
                    預覽(新頁面)
                  </el-dropdown-item>

                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <!-- 分页 -->
    <Pagination
      v-show="total > 0" :total="total" :page.sync="listQuery._page"
      :limit.sync="listQuery._limit" @pagination="clickPagin"/>

      <!-- 删除弹窗 -->
      <deleteDialog titleCh="您確定要刪除此題目嗎？" :centerDialogVisible="centerDialogVisible"
      @confirmFunction="deleteQuestion" @onCancelButton="centerDialogVisible = false;"
      ></deleteDialog>

    <!-- 预览弹窗 -->
    <DialogPreview v-if="previewSwitch" :form="form" @close="previewSwitch = false"></DialogPreview>
  </div>
</template>

<script>
import Pagination from "@/components/Pagination";
import { level } from "@/biz/static-data";
import {getQuestions2, deleteQuestion, putBatchCopyQuestion} from '@/api/question'
import deleteDialog from "@/components/deleteDialog";
import DialogPreview from './dialog'

export default {
  components: {
    Pagination,
    deleteDialog,
    DialogPreview
  },
  data() {
    return {
      selectedRows: [],
      total: 0,
      level,
      questionTypes: [
        { label: "全部", "value": null },
        { label: "選擇題", value: 0},
        { label: "判斷題", value: 1},
        { label: "填空題", value: 2},
        { label: "算術題(定數)", value: 3},
        { label: "熱點圖", value: 4},
        { label: "文字拖拽", value: 5},
        { label: "連線題", value: 6},
        { label: "圖片拖拽題", value: 7},
        { label: "算術題(變數)", value: 8},
        { label: "文字拖拽(分類)", value: 9},
        { label: "矩陣填空", value: 10},
      ],
      language: [
        { "label": "全部", "value": null },
        { "label": "中文", "value": 0 },
        { "label": "英文", "value": 1 }
      ],
      listQuery: {
        questionNoLike: null,
        editorLike: null,
        level: null,
        lang: null,
        type: null,
        answerTotalCount:0,
        _page: 1,
        _limit: 10,
      },
      tableData: [],
      curQuestion: {},

      form: {},
      form2: {},
      centerDialogVisible: false,
      previewSwitch: false
    };
  },
  mounted() {
    this.getQuestions();
  },
  methods: {
    // 新标签页打开预览页面
    openPreviewInNewTab(row) {
      // 1. 生成预览页面的URL（拼接form参数）
      const previewPath = this.$router.resolve({
        path: '/preview',
        query: {
          form: JSON.stringify(row)
        }
      }).href
      // window.open(this.$router.resolve({path: `/question/${id}/edit`}).href, '_blank');
      // 2. 打开新标签页
      window.open(previewPath, '_self')
    },
    openDialogPreview(row) {
      this.form = JSON.parse(JSON.stringify(row))
      this.previewSwitch = true
    },
    // 处理列表顺序
    handleSortChange(column) {
      // console.log(column)
      if (column.order === "descending") {
        this.listQuery.orderBy = column.prop + " desc";
      } else if (column.order === "ascending") {
        this.listQuery.orderBy = column.prop + " asc";
      } else {
        this.listQuery.orderBy = null;
      }
      this.listQuery._page = 1;
      this.getQuestions();
    },
    onReset() {
      Object.keys(this.listQuery).forEach(key => {
         this.listQuery[key] = null
         if(key === '_page'){
            this.listQuery[key] = 1
         }
         if(key === '_limit'){
            this.listQuery[key] = 50
         }
      })
      this.getQuestions();
    },
    // 搜索
    onSearch() {
      this.listQuery._page = 1;
      this.getQuestions();
    },
    onAdd(){
      window.open(this.$router.resolve({path: `/question/add`}).href, '_self');
    },
    onCopyButton(id) {
      window.open(this.$router.resolve({path: `/question/${id}/copy`}).href, '_self');
    },
    // 处理复选框选择变化
    handleSelectionChange(selection) {
      this.selectedRows = selection;
    },
    batchCopy() {
      if (this.selectedRows.length === 0) {
        this.$message.warning('請選擇數據！');
        return;
      }

      // 通过事件传递选中的多行数据
      // this.$emit('batch-select', this.selectedRows);
      // 如果需要同时触发单行选择事件（可选）
      this.form2.ids = this.selectedRows.map(row => row.id).join(',');
      putBatchCopyQuestion(this.form2).then(() => {
        this.$message.success('批量複製成功')
        this.onSearch()
      })
    },
    onEditButton2(id) {
      window.open(this.$router.resolve({path: `/question/${id}/edit`}).href, '_blank');
    },
    onEditButton(id) {
      window.open(this.$router.resolve({path: `/question/${id}/edit`}).href, '_self');
    },
    onDetailButton(id) {
      window.open(this.$router.resolve({path: `/question/${id}`}).href, '_self');
    },
    onDeleteButton(row) {
      this.curQuestion = {...row}
      this.centerDialogVisible = true
    },
    // 删除题目
    deleteQuestion() {
      deleteQuestion(this.curQuestion.id)
        .then(() => {
          this.listQuery._page = 1
          this.getQuestions();
        })
        .finally(() => {
          this.centerDialogVisible = false;
        });
    },
    clickPagin(listQuery) {
      this.listQuery._page = listQuery.page
      this.listQuery._limit = listQuery.limit

      this.getQuestions()
    },
    getQuestions() {
      let listQuery = {...this.listQuery}
      listQuery._page -= 1
      getQuestions2(listQuery).then((v) => {
        v.data.filter(its => {
          its.typeConvert = this.questionTypes[its.type + 1].label
          its.langConvert = this.language[its.lang + 1].label
        })
        // 按照更新时间排序
        // v.data.sort((cur, next) => (new Date(next.updatedAt)) - (new Date(cur.updatedAt)))
        this.tableData = v.data;
        this.total = Number(v.headers["x-total-count"]);
      }).catch(err => {
        if (err.response.status === 401) {
          this.getQuestions()
        }
      })
    },
  }
};
</script>

<style lang="scss" scoped>
.page {
  .layout {
    .el-row {
      padding: 20px;
      margin-bottom: 20px;

      &:last-child {
        margin-bottom: 0;
      }

      .title {
        font-size: 30px;
      }
    }

    .el-button--text {
      color: #166ea5;
      font-size: 16px;
    }
  }
}

.page-box {
  background-color: #fff;
}
.button-el-el {
  width: 100%;
  margin-top: 23px;
}
.page-box-content{
  width: 100%;
  overflow-x: auto;
}
.page-content-row {
    display: grid;
    padding: 5px;
    grid-template-columns: repeat(6, 170px);
    grid-template-rows: repeat(1, 1fr);
    gap: 8px;
    align-items: end;
}
.page-content-row>div{
  min-width: 170px;
}
:deep(.el-table .el-table__cell) {
  // 单元格不换行
  white-space: nowrap !important;
  // 行距变小
  line-height: 1.5 !important;
  // 内边距缩小，让行更紧凑
  padding-top: 2px !important;
  padding-bottom: 2px !important;
}
</style>